import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useDebounce from "../../helper/hooks/useDebounce";
import { SEARCH_REGISTRATION_VALUE } from "../../redux/constants/searchBarConstants";

const RegistrationSearch = ({ style }) => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 700);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: SEARCH_REGISTRATION_VALUE,
      payload: {
        value: debouncedSearch,
      },
    });
  }, [debouncedSearch]);

  return (
    <form
      className="hidden md:flex items-center my-4 mx-2"
      onSubmit={(event) => event.preventDefault()}
      style={{ ...style }}
    >
      <label htmlFor="simple-search" className="sr-only">
        Search
      </label>
      <div className="relative w-full ">
        <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
          <svg
            aria-hidden="true"
            className="w-5 h-5 text-gray-500 dark:text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>
        <input
          type="text"
          id="simple-search"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-[380px] pl-10 p-1  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary"
          placeholder="Find People"
          required={true}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        ></input>
      </div>
    </form>
  );
};

export default RegistrationSearch;
